// Redirection automatique d'après la langue du browser
export function autoRedirectToBrowserLang( redirectType ) {

	// Vérifie si l'utilisateur a déjà été redirigé
	if( document.cookie.includes("lang_redirected=true") ) {
		return;
	}

	let redirectBase;

	switch( redirectType ) {

		case 'get':
			redirectBase = window.location.pathname + '?lang=';
		break;

		case 'home':
			redirectBase = rootURL;
		break;

		default:
			redirectBase = rootURL + 'page/changelang/';
	}

	// Liste des langues prises en charge
	const langues = {
		"fr": "french",
		"en": "english",
		"es": "spanish",
		"hi": "hindi"
	};

	// Détecte la langue du navigateur
	const langNavigateur = navigator.language.slice(0, 2).toLowerCase();

	// Vérifie si la langue est supportée
	if (langues[langNavigateur]) {
		const url = redirectBase + langues[langNavigateur];

		// Définit un cookie pour éviter de rediriger à chaque visite
		document.cookie = "lang_redirected=true; path=/; max-age=" + (30 * 24 * 60 * 60) + ";"; // 1 jour

		// Redirection
		window.location.href = url;
	}
}